import { Action } from 'redux';

import { AvailableActionsForEntityRequest, AvailableActionsForEntityRequestSucceeded } from '~src/app/actions/AppActionTypes';
import { isActionFactory } from '~src/app/actions/isActionFactory';
import { ExplorableItemType } from '~src/spacesPlatform/models/ContentType';
import { IExplorableItemTypeInfo } from '~src/ts/models/resourceInfoParts';
import { IWorkbookActions } from '~src/workbook/ServerApi/types/IWorkbookActions';

/**
 * Only the ExploreContentApi item types are eligible for requesting available actions,
 * but for simplicity of dispatching from the views, we can pass in any explorable item type,
 * and the saga makes the API call only for the eligible item types.
 */
export interface AvailableActionsForEntityRequestAction extends Action {
  item: IExplorableItemTypeInfo;
}

export function requestAvailableActionsForEntity(item: IExplorableItemTypeInfo): AvailableActionsForEntityRequestAction {
  return {
    type: AvailableActionsForEntityRequest,
    item
  };
}

export const isAvailableActionsForEntityAction = isActionFactory<AvailableActionsForEntityRequestAction>(AvailableActionsForEntityRequest);

export interface AvailableActionForEntityRequestSucceededAction extends Action {
  entityType: ExplorableItemType;
  entityId: string;
  availableActions: IWorkbookActions;
}

export function availableActionForEntityRequestSucceeded(entityType: ExplorableItemType, entityId: string, availableActions: IWorkbookActions): AvailableActionForEntityRequestSucceededAction {
  return {
    type: AvailableActionsForEntityRequestSucceeded,
    entityType,
    entityId,
    availableActions
  };
}

export const isAvailableActionForEntityRequestSucceededAction = isActionFactory<AvailableActionForEntityRequestSucceededAction>(AvailableActionsForEntityRequestSucceeded);
